import { type } from "arktype";
import { Adaptation, Modality, MovementPattern } from "./vocabulary";

export const Exercise = type({
  id: "string",
  name: "string",
  "aliases?": "string[]",
  pattern: MovementPattern,
  primaryAdaptations: Adaptation.array(),
  "secondaryAdaptations?": Adaptation.array(),
  modality: Modality,
  unilateral: "boolean",
  /** e.g. "per_hand" | "total" | "bodyweight" | "time" | "distance" */
  loadConvention: "'per_hand' | 'total' | 'bodyweight' | 'time' | 'distance'",
  "impact?": "boolean",
});
export type Exercise = typeof Exercise.infer;

// R-DOM-07: comparability is data.
export const relationKinds = ["variant_of", "regression_of", "progression_of", "comparable_for", "related_not_comparable"] as const;
export const RelationKind = type.enumerated(...relationKinds);
export type RelationKind = typeof RelationKind.infer;

export const metrics = ["top_set_load", "reps_at_load", "time", "distance", "est_1rm"] as const;
export const Metric = type.enumerated(...metrics);
export type Metric = typeof Metric.infer;

export const ExerciseRelation = type({
  id: "string",
  fromExerciseId: "string",
  toExerciseId: "string",
  kind: RelationKind,
  "metric?": Metric,
});
export type ExerciseRelation = typeof ExerciseRelation.infer;
